import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const ICON_BTN = 'w-8 h-8 grid place-items-center rounded-md border border-[#cbd3df] bg-white text-[#0d1524] hover:bg-[#f6f7fa] disabled:opacity-35 disabled:cursor-not-allowed disabled:hover:bg-white transition';

/**
 * Top bar for pages you drill into: a real Back button, the path you took, and
 * (optionally) a pager to step through the list you came from.
 *
 * pager: { index, total, onPrev, onNext, prevTitle, nextTitle, noun }
 */
function PageNav({ backLabel, onBack, crumbs = [], pager }) {
  return (
    <div className="flex flex-wrap items-center justify-between gap-3 mb-4">
      <div className="flex items-center gap-2.5 min-w-0">
        <button
          type="button"
          onClick={onBack}
          title={`Back to ${backLabel} (Esc)`}
          className="inline-flex items-center gap-1.5 h-8 pl-2 pr-3 rounded-md border border-[#cbd3df] bg-white text-[13px] font-medium text-[#0d1524] hover:bg-[#f6f7fa] transition flex-none"
        >
          <ChevronLeft size={15} />{backLabel}
        </button>
        <nav aria-label="Breadcrumb" className="flex items-center gap-1.5 min-w-0 text-[13px] text-[#5b6780]">
          {crumbs.map((crumb, i) => {
            const last = i === crumbs.length - 1;
            return (
              <React.Fragment key={`${crumb}-${i}`}>
                {i > 0 && <ChevronRight size={13} className="flex-none text-[#a3adbf]" aria-hidden="true" />}
                <span className={`truncate ${last ? 'font-semibold text-[#0d1524] max-w-[36ch]' : 'max-w-[22ch]'}`} aria-current={last ? 'page' : undefined}>
                  {crumb}
                </span>
              </React.Fragment>
            );
          })}
        </nav>
      </div>

      {pager && pager.index >= 0 && pager.total > 1 && (
        <div className="flex items-center gap-2 flex-none">
          <span className="text-[13px] text-[#5b6780]">
            <b className="font-semibold text-[#0d1524]">{pager.index + 1}</b> of {pager.total}{pager.noun ? ` ${pager.noun}` : ''}
          </span>
          <button type="button" onClick={pager.onPrev} disabled={!pager.onPrev}
            aria-label="Previous" title={pager.prevTitle ? `Previous: ${pager.prevTitle} (←)` : 'Previous (←)'} className={ICON_BTN}>
            <ChevronLeft size={16} />
          </button>
          <button type="button" onClick={pager.onNext} disabled={!pager.onNext}
            aria-label="Next" title={pager.nextTitle ? `Next: ${pager.nextTitle} (→)` : 'Next (→)'} className={ICON_BTN}>
            <ChevronRight size={16} />
          </button>
        </div>
      )}
    </div>
  );
}

export default PageNav;
